import React, { useState, useEffect } from 'react';

const RegenerateModal = ({ isOpen, onClose, onSubmit, isLoading = false }) => {
  const [formData, setFormData] = useState({
    reason: '',
    role: '',
    goal: '',
    constraints: ''
  });
  const [isCustomPromptVisible, setCustomPromptVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const toggleCustomPrompt = () => {
    setCustomPromptVisible(!isCustomPromptVisible);

    if (!isCustomPromptVisible) {
      // if custom prompt is visible, then set reason to empty
      setFormData(prev => ({ ...prev, reason: '' }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCustomPromptVisible) {
      if (onSubmit) {
        onSubmit({
          reason: formData.reason,
          role: formData.role,
          goal: formData.goal,
          constraints: formData.constraints
        });
      }
    } else {
      if (onSubmit) {
        onSubmit(formData.reason);
      }
    }
    setFormData({ reason: '', role: '', goal: '', constraints: '' });
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-content bg-white">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title">Regenerate response / Custom prompt</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          
          <div className="modal-body pt-4">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">
                  Reason for Regeneration <span className="text-danger">*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  placeholder="Feedback / Issues with current output"
                  disabled={isCustomPromptVisible}
                />
              </div>

              <div className="mb-3">
  <button 
    type="button" 
    className="btn btn-link p-0"
    onClick={toggleCustomPrompt}
    style={{ textDecoration: "none", padding: 0 }}
  >
    <div style={{color: "#212529"}}>
      {isCustomPromptVisible ? (
        <>
          Hide Custom Prompt 
          <i 
            style={{
              border: 'solid black',
              borderWidth: '0 3px 3px 0',
              display: 'inline-block',
              padding: '3px',
              transform: 'rotate(-135deg)',
              WebkitTransform: 'rotate(-135deg)',
              marginLeft: '5px'
            }}
          ></i>
        </>
      ) : (
        <>
          Add Custom Prompt 
          <i 
            style={{
              border: 'solid black',
              borderWidth: '0 3px 3px 0',
              display: 'inline-block',
              padding: '3px',
              transform: 'rotate(45deg)',
              WebkitTransform: 'rotate(45deg)',
              marginLeft: '5px'
            }}
          ></i>
        </>
      )}</div>
  </button>
</div>



              {isCustomPromptVisible && (
                <div>
                  <label className="form-label my-3">
                    Enter Custom Prompt:
                  </label>
                  <div className="mb-3">
                    <label className="form-label">Role</label>
                    <input
                      type="text"
                      className="form-control"
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                         placeholder="Enter role"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Goal</label>
                    <input
                      type="text"
                      className="form-control"
                      name="goal"
                      value={formData.goal}
                      onChange={handleChange}
                   placeholder="Enter goal"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Constraints</label>
                    <input
                      type="text"
                      className="form-control"
                      name="constraints"
                      value={formData.constraints}
                      onChange={handleChange}
                    placeholder="Enter constraints"
                    />
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-center align-items-center">
                <button 
                  type="submit" 
                  className="btn regenerate-btn text-center"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Regenerating...
                    </>
                  ) : (
                    'Regenerate'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
        }

        .modal-container {
          width: 100%;
          max-width: 520px;
          margin: 1.75rem;
        }

        .modal-content {
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .modal-header {
          padding: 1.5rem 1.5rem 0;
        }

        .modal-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #2d3748;
        }

        .modal-body {
          padding: 1rem 1.5rem 1.5rem;
        }

        .form-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #4a5568;
          margin-bottom: 0.5rem;
        }

        .form-control {
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 0.5rem 0.75rem;
          font-size: 0.875rem;
        }

        .form-control:focus {
          border-color: #E86C51;
          box-shadow: 0 0 0 1px rgba(232, 108, 81, 0.1);
        }

        .regenerate-btn {
          background-color: #E86C51;
          border: none;
          color: white;
          padding: 0.625rem;
          font-weight: 500;
          border-radius: 6px;
          transition: background-color 0.2s;
          text-align:center;
        }

        .regenerate-btn:hover {
          background-color: #D55D44;
          color: white;
        }

        .btn-close {
          opacity: 0.5;
          transition: opacity 0.2s;
        }

        .btn-close:hover {
          opacity: 0.75;
        }
      `}</style>
    </div>
  );
};

export default RegenerateModal;
